<script lang="ts" setup>
    import type { MessageSeverity, SeverityMessage } from '~/types/messages'

    defineProps<{
        messages: SeverityMessage[]
    }>()

    const SEVERITY_BACKGROUNDS: Record<MessageSeverity, string> = {
        info: 'bg-blue-8',
        warning: 'bg-orange-8',
        error: 'bg-red-8',
    }
</script>

<template>
    <div class="column q-gutter-sm">
        <q-banner
            v-for="(message, index) in messages"
            :key="index"
            data-testid="message"
            dense
            rounded
            class="text-white"
            :class="SEVERITY_BACKGROUNDS[message.severity]"
        >
            <template #avatar>
                <q-icon
                    :name="message.severity"
                    data-testid="message-icon"
                />
            </template>
            <strong v-if="message.label">{{ message.label }}</strong>
            {{ message.text }}
        </q-banner>
    </div>
</template>
